import {
  formatPurchasePlanningCurrency,
  formatPurchasePlanningCashRequired,
  formatPurchasePlanningNumber,
} from '../../../lib/purchasePlanningHelpers';

export function InventoryCapitalPlanMonthRail({ monthSummaries }) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-2 lg:p-4">
      <div>
        <h3 className="text-sm font-semibold text-gray-900">Cash by PO window</h3>
        <p className="mt-1 text-xs text-gray-500">
          Cash is bucketed by consolidated supplier PO windows (March, June, December — aligned
          with Upcoming Buys), not per-SKU reorder deadlines. Next PO required remains the
          coverage deadline on each row.
        </p>
      </div>
      <div className="mt-4 space-y-2">
        {monthSummaries.length > 0 ? (
          monthSummaries.map(entry => (
            <div key={entry.month} className="rounded-md border border-gray-200 bg-white px-3 py-3">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="text-sm font-medium text-gray-900">{entry.month}</p>
                  <p className="mt-1 text-xs text-gray-500">
                    {formatPurchasePlanningNumber(entry.skuCount)} SKU
                    {entry.skuCount === 1 ? '' : 's'}
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-sm font-semibold text-gray-900">
                    {formatPurchasePlanningCashRequired(entry.cashRequired)}
                  </p>
                  <p className="mt-1 text-xs text-gray-500">
                    {formatPurchasePlanningNumber(entry.adjustedRoundedUnits)} units
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="rounded-md border border-dashed border-gray-200 bg-white px-4 py-6 text-sm text-gray-500">
            No month buckets are in scope for the current filters.
          </div>
        )}
      </div>
    </div>
  );
}

export function InventoryCapitalPlanCategoryRail({ categorySummaries }) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-2 lg:p-4">
      <div>
        <h3 className="text-sm font-semibold text-gray-900">Cash by category</h3>
        <p className="mt-1 text-xs text-gray-500">
          Finance can see which product families drive working-capital deployment once governed
          rounded buys are approved.
        </p>
      </div>
      <div className="mt-4 space-y-2">
        {categorySummaries.length > 0 ? (
          categorySummaries.map(entry => (
            <div key={entry.category} className="rounded-md border border-gray-200 bg-white px-3 py-3">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="text-sm font-medium text-gray-900">{entry.category}</p>
                  <p className="mt-1 text-xs text-gray-500">
                    {formatPurchasePlanningNumber(entry.skuCount)} SKU
                    {entry.skuCount === 1 ? '' : 's'}
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-sm font-semibold text-gray-900">
                    {formatPurchasePlanningCashRequired(entry.cashRequired)}
                  </p>
                  <p className="mt-1 text-xs text-gray-500">
                    {formatPurchasePlanningNumber(entry.adjustedRoundedUnits)} units
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="rounded-md border border-dashed border-gray-200 bg-white px-4 py-6 text-sm text-gray-500">
            No category totals are in scope for the current filters.
          </div>
        )}
      </div>
    </div>
  );
}
